import React, { useEffect, useState } from "react";
import { ISpecialMattressProps } from "../../models/interface/ISpecialMattressProps";
import { getImageOrVideoPath } from "../../shared/helpers";
import "./style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { WIDTH_HEADER } from "../../common/constant";

gsap.registerPlugin(ScrollTrigger);

interface ISpecialMattressGifsProps extends ISpecialMattressProps {
  sectionGifs: any;
}

const SpecialMattressGifs = (props: ISpecialMattressGifsProps) => {
  const { sectionGifs } = props;
  const { innerWidth } = window;
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const _marker = innerWidth > WIDTH_HEADER ? 160 : 120;

  useEffect(() => {
    let st: any;
    if (isLoaded) {
      st = gsap.from(".kd-special-mattress", {
        scrollTrigger: {
          trigger: ".kd-special-mattress-gifs",
          start: `-${_marker}px top`,
          end: `bottom ${_marker}px`,
          pin: true,
          pinSpacing: false,
          // markers: true,
        },
      });
    }

    return () => {
      if (st) {
        st.scrollTrigger.kill();
      }
    };
  }, [isLoaded]);

  return (
    <div className="kd-special-mattress-gifs">
      {sectionGifs ? (
        <img
          src={getImageOrVideoPath(sectionGifs.images)}
          alt=""
          onLoad={() => setIsLoaded(true)}
        />
      ) : null}
    </div>
  );
};

export default SpecialMattressGifs;
